<br>
<div class="col-lg-12 animated fadeIn">
  <i><u> <h4 style="text-align: center;">GESTION DE EMPRESAS</h4></u></i>
  <br>
  <div>
    <label for="cuit">CUITs Dispo</label>
    &nbsp;
    <app-cuit-input [(ngModel)]="filtroCuit" name="filtroCuit" inputClass="form-chico" placeholder="CUIT.."></app-cuit-input>
    &nbsp;
    <select  [(ngModel)]="filtroCuit" name="filtroCuit" id="filtroCuit" class="form-chico">
      <option value="TODOS">TODOS</option>
      <option *ngFor="let cuits of dataSourceEmpresas" [ngValue]="cuits.cuit">{{ cuits.razon }} -{{cuits.deuda | currency:"$" }}</option>
    </select>
  </div>
  <hr>
  <div style="text-align: center;">
    <button *ngIf="role === 'ADMIN' || role === 'DATAENTRY'" type="button" class="btn btn-info" data-toggle="modal" data-target="#MODALINSERTAR"><img src="../../../../assets/img/newww.png" style="width: 40px; height: 40px;"> AGREGAR EMPRESA</button>
  </div>  
  <hr>
  <div style="text-align: center;" *ngIf="loading" class="animated fadeIn">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    <hr>
  </div>
  <div *ngIf="dataSourceOpe != null" class="animated fadeIn">
    <table mat-table [dataSource]="dataSourceOpe" class="mat-elevation-z8 animated fadeIn">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    
      <!-- Name Column -->
      <ng-container matColumnDef="cuit">
        <th mat-header-cell *matHeaderCellDef> CUIT </th>
        <td mat-cell *matCellDef="let element"> {{element.cuit}} </td>
      </ng-container>
    
      <!-- Weight Column -->
      <ng-container matColumnDef="razon">
        <th mat-header-cell *matHeaderCellDef> EMPRESA </th>
        <td mat-cell *matCellDef="let element"> {{element.razon}} </td>
      </ng-container>

      <!-- Symbol Column 
      <ng-container matColumnDef="deuda">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> DEUDA</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.deuda | currency:"$"}} </td>
      </ng-container>
    -->
      <!-- Symbol Column -->
      <ng-container matColumnDef="contacto">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> CONTACTO </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">
         {{ element.contacto }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="responsable">
        <th mat-header-cell *matHeaderCellDef> RESPONSABLE </th>
        <td mat-cell *matCellDef="let element">
         {{ element.responsable }}
        </td>
      </ng-container>

        <!-- Symbol Column -->
      <ng-container matColumnDef="cct">
        <th mat-header-cell *matHeaderCellDef> CCT </th>
        <td mat-cell *matCellDef="let element"> 
         {{element.cct}}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef> SECCIONAL </th>
        <td mat-cell *matCellDef="let element">
            {{ element.descripcion }}
        </td>
      </ng-container>

      <!-- borrar Column -->
      <ng-container matColumnDef="x">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> EDICION </th>
        <td mat-cell *matCellDef="let element">
            <button [disabled]="role !== 'DATAENTRY' && role !== 'ADMIN'" *ngIf="permitir == false" id="botonBorraModal" mat-icon-button color="accent" data-toggle="modal" data-target="#MODALEDITAR">
                <mat-icon style="color: blue;" aria-label="Delete">edit</mat-icon>
            </button>
            <button [disabled]="role !== 'DATAENTRY' && role !== 'ADMIN'" *ngIf="permitir == false" id="botonBorraModal" mat-icon-button color="accent" data-toggle="modal" data-target="#MODALBORRAR">
              <mat-icon aria-label="Delete">delete</mat-icon>
            </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="selection.toggle(row)">
      </tr>
    </table>
  </div>
  <hr>
</div>


<!-- Modal REPORTE -->
<div style="margin-top: 100px" class="modal fade" id="MODALDATOS" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div [class]="modalessHeader">
              <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">ID:&nbsp;</p>
              <p style="font-weight: bold" *ngIf="item">{{item[0].id}}&nbsp;"{{item[0].empresa}}"&nbsp;CCT: {{item[0].cct}}&nbsp;- SEC:&nbsp;{{item[0].descripcion}}</p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div [class]="modalessBody" #REPORTE>
              <label for="obs">Novedad</label>
              <input *ngIf="obse == false" disabled type="text" [(ngModel)]="modifobs" name="modifobs" class="form-control">&nbsp;
              <input *ngIf="obse == true" type="text" [(ngModel)]="modifobs" name="modifobs" class="form-control">&nbsp;
              <mat-icon *ngIf="obse == false" (click)="habilitaobs()" style="cursor: pointer;" aria-label="ACEPTAR">select_all</mat-icon>
              <mat-icon *ngIf="obse ==true" (click)="habilitaobs()" style="cursor: pointer;" aria-label="ACEPTAR">check</mat-icon>
              &nbsp;&nbsp;
              <mat-icon *ngIf="obse ==true" (click)="habilitaobs()" style="cursor: pointer;" aria-label="ACEPTAR">close</mat-icon>
              <br>
              <br>
              <label for="est">Estado</label>
              <input *ngIf="status == false" disabled type="text" [(ngModel)]="modifestado" name="modifestado" class="form-control">
              <select *ngIf="status == true" [(ngModel)]="modifestado" name="modifestado" class="form-control">
                <option value="ACUERDO P/CARGAR">ACUERDO P/CARGAR</option>
                <option value="CONCURSO PREVENTIVO">CONCURSO PREVENTIVO</option>
                <option value="DEUDA">DEUDA</option> 
                <option value="INUBICABLES">INUBICABLES</option>
                <option value="PAGADO">PAGADO</option>
                <option value="SIN EMPLEADO / BAJA">SIN EMPLEADO / BAJA</option>
              </select>
              <mat-icon *ngIf="status == false" (click)="habilitaestado()" style="cursor: pointer;" aria-label="ACEPTAR">select_all</mat-icon>
              <mat-icon *ngIf="status ==true" (click)="habilitaestado()" style="cursor: pointer;" aria-label="ACEPTAR">check</mat-icon>
              &nbsp;&nbsp;
              <mat-icon *ngIf="status ==true" (click)="habilitaestado()" style="cursor: pointer;" aria-label="ACEPTAR">close</mat-icon>
          </div>
          <button id="salemodal" type="button" class="btn btn-secondary" data-dismiss="modal">GUARDAR CAMBIOS <i hidden class="fa fa-spinner fa-spin fa-1x fa-fw"></i></button>
      </div>
  </div>
</div>

<!-- Modal REPORTE -->
<div style="margin-top: 100px" class="modal fade" id="MODALINSERTAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div class="modal-header">
              <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">AGREGAR EMPRESA</p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" #REPORTE>
              <app-loading class="m-5" *ngIf="loading"></app-loading>
              <form>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">CUIT</label> 
                    <app-cuit-input [(ngModel)]="pcuit" name="pcuit" placeholder="Ingrese CUIT.."></app-cuit-input>
                  </div>
                </div>
                <div class="form-group">
                  <label for="inputAddress2">RAZON SOCIAL</label>
                  <input type="text" class="form-control" [(ngModel)]="prazon" name="prazon" placeholder="Ingrese nombre de la empresa..">
                </div>
                <div class="form-group">
                  <label for="inputAddress2">CONTACTO</label>
                  <input type="text" class="form-control" [(ngModel)]="pcontacto" name="pcontacto" placeholder="Ingrese telefono y/o mail..">
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">RESPONABLE</label>
                    <input type="text" class="form-control" [(ngModel)]="prespo" name="prespo" placeholder="Ingrese nombre y Apellido..">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">CCT</label>
                    <select [(ngModel)]="pcct" name="pcct" id="pcct" class="form-control">
                      <option value="574/10">574/10 - ACOPIO</option>
                      <option value="639/11">639/11 - PUERTOS PRIVADOS</option>
                      <option value="407/05">407/05 - EXPORTACION Y CONTROL</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="inputCity">SECCIONAL</label>
                    <select  [(ngModel)]="pidsec" name="pidsec" id="pidsec" class="form-control">
                      <option *ngFor="let sec of dataSourceSeccionales" [ngValue]="sec.Codigo">{{ sec.Codigo }}- "{{sec.Descripcion}}"</option>
                    </select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>CALLE <small class="text-muted">(opcional)</small></label>
                    <input type="text" class="form-control" [(ngModel)]="pcalle" name="pcalle" placeholder="Nombre de la calle..">
                  </div>
                  <div class="form-group col-md-3">
                    <label>PUERTA <small class="text-muted">(opcional)</small></label>
                    <input type="text" class="form-control" [(ngModel)]="ppuerta" name="ppuerta" placeholder="Nro..">
                  </div>
                  <div class="form-group col-md-3">
                    <label>COD. POSTAL <small class="text-muted">(opcional)</small></label>
                    <input type="text" class="form-control" [(ngModel)]="pcp" name="pcp" placeholder="CP..">
                  </div>
                </div>

                <div *ngIf="codError != 'NO'"  class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>FALLO!</strong> El cuit ingresado ya existe en la base de datos de Empresas SIDEU.
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <button [disabled]="pcuit == '' || pcuit == null || pcuit.length != 13 ||
                              prazon =='' || prazon == null ||
                              pcontacto == '' || pcontacto == null ||
                              prespo == '' || prespo == null ||
                              pcct == '' || pcct == null ||
                              pidsec == '' || pidsec == null"  
                  type="button" class="btn btn-warning btn-block"
                  (click)="insertaEmpresa()">
                  <span *ngIf="!loadingInsert">INSERTAR EMPRESA NUEVA</span>
                  <span *ngIf="loadingInsert">INSERTANDO... <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i> </span>
                </button>
                <button hidden id="chaumodal" data-dismiss="modal">chaumodal</button>

              </form>
          </div>
          
      </div>
  </div>
</div>


<!-- Modal BORAR NOVEDAD -->
<div style="margin-top: 100px" class="modal fade" id="MODALBORRAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div class="modal-header">
              <p>
                ¿ELIMINAR EMPRESA
                <span style="font-weight: bold" *ngIf="item">{{ item[0].cuit }} - {{ item[0].razon}}?</span>
              </p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" #REPORTE>

            <app-loading class="m-5" *ngIf="loadingEliminar"></app-loading>
            <div *ngIf="errorEliminar" class="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>NO SE PUEDE ELIMINAR!</strong> La empresa que intenta borrar, <strong>contiene novedades asignadas</strong>, si necesita puede actualizar los datos de la misma..
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
          </div>
          <button *ngIf="item" (click)= "eliminarEmpresa(item[0].cuit)"  
                  type="button" class="btn btn-danger">
            ELIMINAR DEFINITIVAMENTE
          </button>
          <button class="btn btn-dark" data-dismiss="modal" id="salirmodal">CANCELAR</button>
      </div>
  </div>
</div>

<!-- Modal EDITAR EMPRESA -->
<div style="margin-top: 100px" class="modal fade" id="MODALEDITAR" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div class="modal-header">
              <p>
                MODIFICAR EMPRESA
                <span style="font-weight: bold" *ngIf="item">{{ item[0].cuit }} - {{ item[0].razon}}?</span>
              </p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" #REPORTE>
            <app-loading *ngIf="loadingUpdate" class="m-5"></app-loading>
            <form>
              <div class="form-group">
                <label for="inputAddress2">RAZON SOCIAL</label>
                <input type="text" class="form-control" *ngIf="item" value="{{ item[0].razon }}" [(ngModel)]="modirazon" name="modirazon">
              </div>
              <div class="form-group">
                <label for="inputAddress2">CONTACTO</label>
                <input type="text" class="form-control" *ngIf="item" value="{{ item[0].contacto }}" [(ngModel)]="modicontac" name="modicontac">
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="inputCity">RESPONABLE</label>
                  <input type="text" class="form-control" *ngIf="item" value="{{ item[0].responsable}}" [(ngModel)]="modirespo" name="modirespo">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="inputCity">CCT</label>
                  <select *ngIf="item" value="{{ item[0].cct }}" class="form-control" [(ngModel)]="modicct" name="modicct">
                    <option value="574/10">574/10 - ACOPIO</option>
                    <option value="639/11">639/11 - PUERTOS PRIVADOS</option>
                    <option value="407/05">407/05 - EXPORTACION Y CONTROL</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="inputCity">SECCIONAL</label>
                  <select  *ngIf="item" value="{{ item[0].Codigo }}" class="form-control" [(ngModel)]="modiidsec" name="modiidsec">
                    <option [selected]="item[0].id_seccional" [ngValue]="item[0].id_seccional">{{ item[0].id_seccional}} - {{ item[0].descripcion }}</option>
                  </select>
                  <br>
                  <button class="btn-info" *ngIf="!mostrarsec" (click)="mostrarSec()" >¿Asignar a otra seccional?</button>
                  <br>
                  <span *ngIf="mostrarsec" >
                    <select [(ngModel)]="secselected" name="secselected" *ngIf="mostrarsec" class="form-control">
                      <option *ngFor="let sec of dataSourceSeccionales" [ngValue]="sec.Codigo">{{ sec.Codigo }}- "{{sec.Descripcion}}"</option>
                    </select>
                    <mat-icon style="color:indigo; cursor: pointer;" (click)="mostrarSec()" aria-label="CANCELAR">
                      cancel
                    </mat-icon>
                  </span>
                </div>
              </div>
            </form>

            <div *ngIf="errorEliminar" class="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>NO SE PUEDE ELIMINAR!</strong> La empresa que intenta borrar, <strong>contiene novedades asignadas</strong>, si necesita puede actualizar los datos de la misma..
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
         
          <button *ngIf="item" (click)=" updateEmpresa(item[0].cuit)"  
                  type="button" class="btn btn-danger">
            GUARDAR CAMBIOS
          </button>
          <button class="btn btn-dark" data-dismiss="modal" id="byemodal">CANCELAR</button>
      </div>
  </div>
</div>
